export type MarkdownAction = {
    label: string;
    title: string;
    icon?: "list";
    before: string;
    after?: string;
    block?: boolean;
    placeholder: string;
};

export const markdownActions: MarkdownAction[] = [
    { label: "B", title: "Vet", before: "**", after: "**", placeholder: "vette tekst" },
    { label: "I", title: "Cursief", before: "*", after: "*", placeholder: "cursieve tekst" },
    { label: "H2", title: "Kop", before: "## ", block: true, placeholder: "Kop" },
    { label: "", title: "Opsomming", icon: "list", before: "- ", block: true, placeholder: "item" },
    { label: "Link", title: "Link", before: "[", after: "](https://)", placeholder: "label" },
];

type MarkdownActionResultaat = {
    waarde: string;
    /** Het stuk tekst dat na de actie geselecteerd moet worden. */
    selectie: [start: number, einde: number];
};

export function applyMarkdownAction(
    action: MarkdownAction,
    waarde: string,
    selectionStart: number,
    selectionEnd: number
): MarkdownActionResultaat {
    if (action.block) {
        const regelStart = waarde.lastIndexOf("\n", selectionStart - 1) + 1;
        const volgendeNewline = waarde.indexOf("\n", selectionEnd);
        const regelEinde = volgendeNewline === -1 ? waarde.length : volgendeNewline;

        const regels = waarde
            .slice(regelStart, regelEinde)
            .split("\n")
            .map((regel) => (regel.startsWith(action.before) ? regel : `${action.before}${regel || action.placeholder}`));

        const midden = regels.join("\n");

        return {
            waarde: `${waarde.slice(0, regelStart)}${midden}${waarde.slice(regelEinde)}`,
            selectie: [regelStart, regelStart + midden.length],
        };
    }

    const geselecteerd = waarde.slice(selectionStart, selectionEnd) || action.placeholder;
    const midden = `${action.before}${geselecteerd}${action.after ?? ""}`;
    const start = selectionStart + action.before.length;

    return {
        waarde: `${waarde.slice(0, selectionStart)}${midden}${waarde.slice(selectionEnd)}`,
        selectie: [start, start + geselecteerd.length],
    };
}
